import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EPropertyForRentStatus } from "@rentiohq/shared-frontend/dist/types/property.types";
import { EField, IExtraData } from "./schema.editPropertyInfo.types";

export const getInitialValues = ({
  property,
  roomCountBathroom,
  roomCountGarage,
  livingSurfaceArea,
  descriptionLong,
  virtualTourUrl,
  rentmatchPerfectIncome,
  rentmatchMaxHousehold,
}: IExtraData): IValues => {
  return {
    [EField.Costs]: property.costs,
    [EField.Price]: property.price,
    // Default the publish choice only when it was never set: a property that
    // is "for rent" defaults to Publish (the broker's likely intent), anything
    // else defaults to Do-not-publish. An explicit stored value is respected.
    [EField.IsRentMatchPublished]:
      property.isRentMatchPublished ??
      property.forRentStatus === EPropertyForRentStatus.ForRent,
    [EField.RoomCountBedroom]: property.roomCountBedroom,
    [EField.AvailableAtDate]: property.availableAtDate
      ? new Date(property.availableAtDate)
      : null,
    [EField.ExternalListingUrl]: property.externalListingUrl ?? null,
    // Extra property details — step 2 (amenity-sourced, not on IProperty directly)
    [EField.RoomCountBathroom]: roomCountBathroom ?? null,
    [EField.RoomCountGarage]: roomCountGarage ?? null,
    [EField.LivingSurfaceArea]: livingSurfaceArea ?? null,
    // Direct property fields
    [EField.EpcLabel]: property.epcLabel ?? null,
    [EField.BuildingTerraceSurfaceArea]:
      property.buildingTerraceSurfaceArea ?? null,
    [EField.BuildingGardenSurfaceArea]:
      property.buildingGardenSurfaceArea ?? null,
    [EField.DescriptionLong]: descriptionLong ?? null,
    [EField.VirtualTourUrl]: virtualTourUrl ?? null,
    // One value, because the two are one block on screen. Split again on the
    // way out, into the two amenity rows they are stored as.
    [EField.RentmatchScore]: {
      perfectIncome: rentmatchPerfectIncome ?? null,
      maxHousehold: rentmatchMaxHousehold ?? null,
    },
  };
};
